import { ButtonGroup as Bs5ButtonGroup } from 'react-bootstrap5';

export default Bs5ButtonGroup;
